import { Colors } from "@/enums/Colors";
import { Checkbox, CheckboxProps, Typography, styled } from "@mui/material";
import { CSSProperties } from "react";

const StyledCheckbox = styled(Checkbox)(({}) => ({
  "&.MuiCheckbox-root": {
    color: `${Colors.LIGHT_GRAY_DEDEE1}`,
    "&.MuiCheckbox-indeterminate": {
      color: `${Colors.LAZO_PURPLE}`,
    },
    ":hover": {
      color: `${Colors.STROKE_DARK_GRAY}`,
    },
    "&.Mui-checked": {
      color: `${Colors.LAZO_PURPLE}`,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.3rem",
    },
  },
}));

interface Props extends CheckboxProps {
  label?: string;
  direction?: "row" | "row-reverse";
  textStyle?: CSSProperties;
}

export const LazoCheckbox = (props: Props) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: props.direction ?? "row",
      }}
    >
      <StyledCheckbox {...props} />
      {props.label && <Typography sx={props.textStyle}>{props.label}</Typography>}
    </div>
  );
};
